/* Transcribed from the supplier height/weight recommendation supplied by the owner.
   null = slash/no advice; 'unclear' = unreadable "One" at 180cm / 47.5kg.
   These are size labels, not measured waist circumferences. */
(()=>{'use strict';
const heights=[155,160,165,170,175,180,185,190];
const rows=[
[45,28,28,28,null,null,null,null,null],
[47.5,28,28,28,28,28,'unclear',null,null],
[50,28,28,28,28,28,28,null,null],
[52.5,29,29,29,29,29,29,null,null],
[55,30,29,29,29,29,29,30,null],
[57.5,30,30,30,29,29,29,30,null],
[60,31,31,31,30,30,30,30,null],
[62.5,32,32,32,31,30,30,31,null],
[65,33,32,32,31,31,31,31,null],
[67.5,33,33,33,32,31,31,32,null],
[70,34,34,33,32,32,32,32,null],
[72.5,34,34,34,33,33,33,33,null],
[75,35,35,35,34,33,33,33,34],
[77.5,36,35,35,34,34,34,34,34],
[80,36,36,36,35,35,35,34,35],
[82.5,36,36,36,36,35,35,35,35],
[85,38,38,38,38,36,36,36,36],
[87.5,40,38,38,38,36,36,36,36],
[90,null,40,40,40,38,38,38,38],
[92.5,null,null,40,40,38,38,38,38],
[100,null,null,null,40,40,40,38,38],
[110,null,null,null,null,40,40,42,42],
[120,null,null,null,null,null,null,42,42]
];
const lookup=(height,weight)=>{const col=heights.indexOf(Number(height)),row=rows.find(r=>r[0]===Number(weight));return col<0||!row?undefined:row[col+1];};
window.WHITMORE_TROUSER_SIZE_GUIDE={heights,rows,lookup};
const q=s=>document.querySelector(s),dialog=q('#tr-fit-dialog');if(!dialog)return;
q('#sg-height').insertAdjacentHTML('beforeend',heights.map(h=>`<option value="${h}">${h} cm</option>`).join(''));
q('#sg-weight').insertAdjacentHTML('beforeend',rows.map(r=>`<option value="${r[0]}">${r[0]} kg</option>`).join(''));
q('#sg-table').innerHTML=`<caption>Supplier size recommendations by height (cm) and weight (kg)</caption><thead><tr><th scope="col">kg / cm</th>${heights.map(h=>`<th scope="col">${h}</th>`).join('')}</tr></thead><tbody>${rows.map(row=>`<tr><th scope="row">${row[0]} kg</th>${row.slice(1).map((v,i)=>`<td data-sg-height="${heights[i]}" data-sg-weight="${row[0]}"${v===null?' aria-label="No recommendation"':v==='unclear'?' aria-label="Unclear source entry"':''}>${v===null?'—':v==='unclear'?'?':v}</td>`).join('')}</tr>`).join('')}</tbody>`;
let recommendation;
function update(){
 const height=q('#sg-height').value,weight=q('#sg-weight').value;
 recommendation=height&&weight?lookup(height,weight):undefined;
 const usable=typeof recommendation==='number'&&[...q('#tr-size').options].some(o=>o.value===String(recommendation));
 q('#sg-apply').hidden=!usable;
 q('#sg-result').classList.toggle('has-size',typeof recommendation==='number');
 q('#sg-number').textContent=typeof recommendation==='number'?String(recommendation):'—';
 q('#sg-result-label').textContent=typeof recommendation==='number'?'Your suggested size':'Find your starting point';
 q('#sg-result-note').textContent=!height||!weight?'Choose your height and weight above.':recommendation==='unclear'?'This entry is unclear in the supplier chart. Ask us for help rather than guessing.':recommendation===null?'The supplier gives no recommendation for this combination. Contact us for sizing advice.':!usable?`The chart suggests size ${recommendation}, which is not currently listed for this trouser. Please ask us before choosing another size.`:`Based on the supplier chart for ${height} cm / ${weight} kg. A starting point, not a guaranteed fit.`;
 q('#sg-apply').textContent=usable?`Use size ${recommendation} for this pair ↗`:'Use this size';
 document.querySelectorAll('[data-sg-height]').forEach(cell=>{const selected=cell.dataset.sgHeight===height&&cell.dataset.sgWeight===weight;cell.classList.toggle('sg-selected',selected);if(selected)cell.setAttribute('aria-current','true');else cell.removeAttribute('aria-current');});
}
q('#sg-height').addEventListener('change',update);q('#sg-weight').addEventListener('change',update);
q('#sg-apply').addEventListener('click',()=>{if(typeof recommendation!=='number'||q('#sg-apply').hidden)return;document.dispatchEvent(new CustomEvent('trouser-size-selected',{detail:{size:String(recommendation)}}));});
update();
})();
